import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    destinatario: {},
  },
  mutations: {
    chargeDestinatario(state, datos) {
      state.destinatario = datos;
    },
    destroyDestinatario(state) {
      state.destinatario = {};
    },
  },
  actions: {
    async chargeDestinatario({ commit }, destinatario) {
      commit('chargeDestinatario', destinatario);
    },
    async destroyDestinatario({ commit }) {
      commit('destroyDestinatario');
    },
  },
};
